import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
	name    : "update-subscription",
	computed: {
		...mapGetters({
			user            : 'user/user',
			currentPlan     : "userPaymentsHistory/currentPlan",
		}),
	},
	methods : {
		...mapActions({
			updateTariff    : "user/UPDATE_USER_TARIFF",
			paymentTariff   : "user/PAYMENT_USER_TARIFF",
		}),
		...mapMutations({
			changeShowPopup : "userPaymentsHistory/CHANGE_POPUP_UPDATE_SUBSCRIPTION",
		}),
		updatePlan(item) {
			this.changeShowPopup(false);
			
			if(!this.user.email){
				return false;
			}
			
			try {
				this.updateTariff(item)
					.then((response) => {
						if(response){
							const send = {
								"full_name" : this.user.personalData.data.fullName,
								"email"     : this.user.email,
								"phone"     : this.user.phone,
								"entity_id" : response.tariffId
							};
							
							this.paymentTariff(send)
								.then((response) => {
									if(response){
										window.location.href = response.url;
									}
								});
						}else{
							this.$toasted.success(this.$t("successUpdateTariff"));
							
							this.changeShowPopup(false);
						}
					});
			} catch (e) {
				console.log('error:');
				console.log(e);
			}
		},
		getDays(){
			//return 0;
			
			if(!this.currentPlan){
				return 0;
			}
			
			var activeTo = this.currentPlan.activeTo.split(" ")[0]+" 00:00:00";
			
			var date = new Date();
			
			var now_utc = Date.UTC(
				date.getUTCFullYear(), 
				date.getUTCMonth(),
				date.getUTCDate(),
				date.getUTCHours(),
				date.getUTCMinutes(),
				date.getUTCSeconds()
			);
			
			var currectDate = new Date(now_utc).toISOString();
			currectDate = currectDate.replace("T", " ");
			currectDate = currectDate.split(" ")[0]+" 00:00:00";
			
			// Ваши даты
			const date1 = new Date(activeTo);
			const date2 = new Date(currectDate);
			
			if(date1 < date2){
				return 0;
			}
			
			// Вычисление разницы в миллисекундах
			const diffInMs = Math.abs(date2.getTime() - date1.getTime());
			
			// Преобразование разницы в дни
			const diffInDays = Math.ceil(diffInMs / (1000 * 60 * 60 * 24));
			
			//console.log('diffInDays2:', diffInDays);
			
			return diffInDays;
		},
		endDate(){
			if(!this.currentPlan){
				return '';
			}
			
			//
			
			var activeTo = this.currentPlan.activeTo.split(" ")[0];
			activeTo = activeTo.split("-");
			activeTo = activeTo.reverse();
			activeTo = activeTo.join(".");
			
			//console.log('endDate activeTo:', activeTo);
			
			return activeTo;
		},
		nextDate(){
			if(!this.currentPlan){
				return '';
			}
			
			//
			
			var activeTo = this.currentPlan.activeTo.split(" ")[0]+" 00:00:00";
			
			var date = new Date(activeTo);
			date.setDate(date.getDate() + this.currentPlan.tariff.data.days);
			date = date.toISOString();
			date = date.replace("T", " ");
			date = date.split(" ")[0];
			date = date.split("-");
			date = date.reverse();
			date = date.join(".");
			
			//console.log('nextDate date:', date);
			
			return date;
		}
	},
};
